(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('testEmpty', ['$uibModal', '$http' , '$log', '$q', function($uibModal, $http, $log, $q){
		return {
			// restrict : 'CA',
			// scope: {
			// 	ngModel : '=ngModel',
			// 	source : '=source'
			// },
			// require: 'ngModel',
			// link: function (scope, element, attrs, ngModelCtrl) {
			// 	if(ngModelCtrl)
			// 	{
			// 		ngModelCtrl.$setViewValue('test...');
			// 	}
			// 	element.autocomplete({
			// 		serviceUrl: attrs.url,
			// 		onSelect : function(data){
			// 			scope.ngModel = data.dataId;
			// 		}
			// 	});
			// }
		};
	}]);
})();

//# sourceMappingURL=directives.js.map
